module.exports = __webpack_public_path__ + "img/voucher8.5a4325a2.png";